import type { SVGProps } from "react";

/**
 * Lobu icon system v3 (24×24, 2.0 stroke, round caps/joins, currentColor) —
 * replaces the lucide glyphs on the owner nav sections and utility buttons.
 * Sized like lucide: renders 24px by default, overridable via `className`
 * size utilities (recommended UI size 18–24px).
 */
function LobuIcon({ children, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			data-lobu-icon=""
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
			fill="none"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			{...props}
		>
			{children}
		</svg>
	);
}

export function ActivityWaveIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon viewBox="1.2 1.2 21.6 21.6" {...props}>
			<path d="M3 11v2" />
			<path d="M6 8.5v7" />
			<path d="M9 5.5v13" />
			<path d="M12 3v18" />
			<path d="M15 5.5v13" />
			<path d="M18 8.5v7" />
			<path d="M21 11v2" />
		</LobuIcon>
	);
}

export function HomeIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon {...props}>
			<path d="M3 10a2 2 0 0 1 .7-1.5l7-6a2 2 0 0 1 2.6 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
			<path d="M9 21v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7" />
		</LobuIcon>
	);
}

export function AgentsChipIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon viewBox="1.74 0.79 20.52 20.52" {...props}>
			<path d="M11 2.5 4.8 8.7v7.6l3.3 3.3h8.1l3-3.1V9.3L16 6.1h-5V2.5Z" />
			<circle cx="10.4" cy="12.4" r="1.15" fill="currentColor" stroke="none" />
			<circle cx="14.7" cy="12.4" r="1.15" fill="currentColor" stroke="none" />
		</LobuIcon>
	);
}

export function AutomationsIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon viewBox="1.35 1.35 19.8 19.8" {...props}>
			<path d="M5.5 13V8.5A3.5 3.5 0 0 1 9 5h10" />
			<path d="m17 3 2 2-2 2" />
			<path d="M18.5 9v6.5A3.5 3.5 0 0 1 15 19H9" />
			<rect x="3.5" y="15.5" width="4" height="4" rx=".4" />
			<path
				d="m13.1 8.2-3.3 4.7h2.5L11 16.8l3.7-5.1h-2.6l1-3.5Z"
				fill="currentColor"
				stroke="none"
			/>
		</LobuIcon>
	);
}

export function ConnectorsIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon viewBox="0.35 1.8 20.4 20.4" {...props}>
			<path d="M18.5 5.5A8.5 8.5 0 1 0 18.5 18.5" />
			<path d="M2.6 12h5.9" />
			<path d="M13.5 8.5H12a3.5 3.5 0 0 0 0 7h1.5V8.5Z" />
			<path d="M13.5 10.5h4" />
			<path d="M13.5 13.5h4" />
		</LobuIcon>
	);
}

export function MemoryLayersIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon viewBox="1.2 1.2 21.6 21.6" {...props}>
			<path d="m12 3.5 8 4.2-8 4.2-8-4.2 8-4.2Z" />
			<path d="m4.5 12.3 6.4 3.4a2.3 2.3 0 0 0 2.2 0l6.4-3.4" />
			<path d="m4.5 16.2 6.4 3.4a2.3 2.3 0 0 0 2.2 0l6.4-3.4" />
		</LobuIcon>
	);
}

export function LobuSearchIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<LobuIcon {...props}>
			<circle cx="11" cy="11" r="8" />
			<path d="m21 21-4.3-4.3" />
		</LobuIcon>
	);
}
